<template>
<div>
    <HeadGetBackBar v-if="showHeadBar"></HeadGetBackBar>
    <div v-if="loading" class="location-loading">
      <van-loading size="24px" vertical></van-loading>
    </div>
    <div v-else>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" ref="routerView" :key="$route.fullPath + cacheKey" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" ref="routerView" ></router-view>
    </div>
    <ScroolTop></ScroolTop>
  </div>
</template>
<script>
import HeadGetBackBar from '@/components/HeadGetBackBar'
import { mapMutations, mapState, mapActions } from 'vuex'

// import backLink from '@/components/BackLink/index.vue'
import ScroolTop from '@/components/ScrollTop'


const passLocation = ['/paymentCashier', '/payOrderStatus']

export default {
  components: {
    // backLink
    ScroolTop,
    HeadGetBackBar
  },
  data () {
    return {
      cacheKey: 0,
     loading: true
    }
  },
  computed: {
    showHeadBar () {
      const showHeadBar = this.$route.meta.showHeadBar
      return (showHeadBar === undefined || showHeadBar === true)
    },
    showScrollTop () {
      const showScrollTop = this.$route.meta.showScrollTop
      return (showScrollTop === undefined || showScrollTop === true)
    },

  },
  methods: {
    ...mapActions('location', ['getLocation']),
    cleanCacheView() {
      // 增加 cacheKey 来强制组件重新渲染
      this.cacheKey++
    },
    async setLocation () {
        if (passLocation.includes(this.$route.path)) {
          this.loading = false
          return
        }
      try {
        await Promise.race([
          this.getLocation(),
          new Promise((_, reject) => setTimeout(() => reject(new Error('定位超时')), 5000))
        ])
      } catch (err) {
        console.log(err, '定位失败')
        this.$toast('定位失败，已为你切换到默认城市')
        // 这里可以手动设置默认城市
        this.$store.state.location.locationInfo = {
          lat: 23.12463,
          lng: 113.36199,
          city: '广州市',
          province: '广东省'
        }
      this.loading = false // 定位完成，显示页面内容
      }
      this.loading = false // 定位完成，显示页面内容
    }
  },
  async created () {
    this.$root.$on('cleanCacheView', () => {
      this.cleanCacheView()
    })
    this.setLocation()
  },
  beforeDestroy() {
    // this.$root.$off('cleanCacheView')
  },
}
</script>
<style lang="scss" scoped>
.location-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
}
</style>